import { XMarkIcon, ChartBarIcon, Bars3BottomLeftIcon, ViewfinderCircleIcon,
   MapIcon, PlusIcon, MagnifyingGlassIcon, ArrowTrendingUpIcon,
    ChartPieIcon, ChartBarSquareIcon, ClockIcon, ArrowDownTrayIcon, NoSymbolIcon,
     DocumentDuplicateIcon, AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';

export function CogGlyph(props) {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    d="M12 8.75a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5z"
  />
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    d="M19 12a7 7 0 00-.08-1l2.02-1.57-2-3.46-2.39.96a7.03 7.03 0 00-1.73-1L14.5 3h-5l-.32 2.93c-.63.25-1.21.58-1.73 1l-2.39-.96-2 3.46L5.08 11A7 7 0 005 12c0 .34.03.67.08 1l-2.02 1.57 2 3.46 2.39-.96c.52.42 1.1.75 1.73 1L9.5 21h5l.32-2.93c.63-.25 1.21-.58 1.73-1l2.39.96 2-3.46L18.92 13c.05-.33.08-.66.08-1z"
  />
</svg>
  );
}

export function DistGlyph(props) {
  return (
    <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6" {...props}>
  <path strokeLinecap="round" strokeLinejoin="round" d="  M10 5.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v14.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V5.625Z   M3 10.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v9.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V10.625Z   M17 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625Z " />
</svg>
  );
}

export function TreeGlyph(props) {
  return (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <g transform="translate(0,2)">
    <path d="M12 3V21
            M12 7 Q 9 7 5 2
            M12 12 Q 18 12 19 5
            M12 15 Q 9 15 4 12" />
    </g>
  </svg>
  );
}

export function TimeStatGlyph(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <g transform="matrix(0.13 0 0 0.13 -4.705 -5.745)">
    <path d="M62 170
             L123 110
             L160 145
             C171 128 181 113 195 103"/>

    <path d="M62 170
             L123 110
             L160 145
             C171 128 181 113 195 103"
          transform="translate(5,32)"/>

    <path d="M62 170
             L123 110
             L160 145
             C171 128 181 113 195 103"
          transform="translate(-5,-32)"/>
  </g>
    </svg>
  );
}

export function BoxPlotGlyph(props) {
  return (
    <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <g transform="scale(0.7) translate(-3.5,-3)"> 
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 15v-6M12 18v-12M17 14v-4M5 15h4M5 9h4M10 18h4M10 6h4M15 14h4M15 10h4" />
    </g>     
  </svg>
  );
}

export function ViolinPlotGlyph(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
     width="24" height="24"
       fill="none" 
      stroke="currentColor" 
      strokeWidth="1.8" 
      strokeLinecap="round" 
      strokeLinejoin="round"  {...props} >
  <path id="right-half" d="M12 22a7 5 0 0 0 7-6c0-2-5-2.9-3-5.5s-0.5-4-4-7c 1-2 3.4-4 5s-3 3.5-3 .5a7 7 0 0 0 7 7z" />
   <use href="#right-half" transform="translate(24 0) scale(-1 1)" />
  </svg>
  );
}


export function LogGlyph(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <text x="1"  y="18" fill="#c2410c" fontSize="16" fontWeight="500" >l</text>
      <text x="4.2" y="18" fill="#c2410c" fontSize="16" fontWeight="500">o</text>
      <text x="13" y="18" fill="#c2410c" fontSize="16" fontWeight="500">g</text>
    </svg>
  );
}

export function ScatterGlyph(props) {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      {...props}
    >
      {/* L-shaped Axis */}
      <path d="M4 4v16h16" stroke="gray" strokeWidth="1.5" />
      {/* Scattered Dots - positioned to be visually centered */}
      <circle cx="9" cy="15" r="1.2" fill="none" stroke="black" strokeWidth="1" />
      <circle cx="14" cy="11" r="1.2" fill="none" stroke="black" strokeWidth="1" />
      <circle cx="12" cy="7" r="1.2" fill="none" stroke="black" strokeWidth="1" />
      <circle cx="18" cy="14" r="1.2" fill="none" stroke="black" strokeWidth="1" />
      <circle cx="17" cy="6" r="1.2" fill="none" stroke="black" strokeWidth="1" />
    </svg>
  );
}

export function PlusButton ({ onClick }) {
    return (
      <button onClick={onClick} className="bg-gray-100 border-2 border-gray-300 hover:bg-gray-200 p-3 rounded-xl transition shadow-sm">
        <PlusIcon className="w-6 h-6 text-gray-600" />
      </button>
    );
  }

export function UploadButton({ onClick }) {
    return (
        <button
         onClick={onClick}
        className="bg-gray-200 hover:bg-gray-300 px-6 py-4 rounded-xl shadow-lg transition">
            Upload Table
        </button>
    );
}

export function BroadcastGeoButton({ onClick,isActive }) {
    return (
          <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className={`inline-flex items-center justify-center w-6 h-6
       rounded-lg border border-gray-400 ${isActive ? 'bg-blue-200' : 'bg-white '} hover:bg-blue-300`}>
       <ViewfinderCircleIcon className="panel-button-icon text-blue-700" />
      </span>
    </button>
    );
}

export function PieBarButton({ onClick, isActive }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-green-300">
        {isActive ? <ChartPieIcon className="panel-button-icon text-green-700" /> : <Bars3BottomLeftIcon className="panel-button-icon text-green-700" />}
      </span>
    </button>
  );
}

export function ViolinBoxButton({ onClick, isActive }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-blue-300">
        {isActive ? <ViolinPlotGlyph className="panel-button-icon text-blue-700" /> : <BoxPlotGlyph className="panel-button-icon text-blue-700" />}
      </span>
    </button>
  );
}

export function TimeButton({ onClick, isActive }) {
  return (
          <button
      onClick={onClick}
      title={`${!isActive ? 'Include' : 'Exclude'} samples \nwith missing dates`}
      className="p-0.5"
    >
      <span className={`inline-flex items-center justify-center w-6 h-6
       rounded-lg border border-gray-400 ${isActive ? 'bg-blue-100' : 'bg-gray-100 '} hover:bg-blue-300`}>
       <ClockIcon className="panel-button-icon text-blue-700" />
      </span>
    </button>
    );
}

export function StatsButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-purple-300">
       <ChartPieIcon className="panel-button-icon text-purple-700" />
      </span>
    </button>
  );
}

export function TimeStatsButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-blue-300">
       <TimeStatGlyph className="panel-button-icon text-blue-700" />
      </span>
    </button>
  );
}

export function PlotButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-orange-300">
        <DistGlyph className="panel-button-icon text-orange-700" />
      </span>
    </button>
  );
}

export function TreeButton({ onClick }) {
  return (
    <button
     onClick={onClick} className="p-0.5"
    >
      <span className="panel-button hover:bg-green-200">
        <TreeGlyph className="panel-button-icon text-green-700" />
      </span>
    </button>
  );
};

export function LogButton({ onClick, isActive,  title = "Toggle log scale on Y" 
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className='p-0.5'
      //title={title}
    >
      <span className={`inline-flex items-center justify-center w-6 h-6 rounded-lg
       ${isActive ? 'bg-orange-100' : 'bg-white-100'}
        border border-gray-400 hover:bg-orange-200`}>
        <LogGlyph className="panel-button-icon text-gray-700" />
      </span>
    </button>
  );
}

export function ScatterButton({ onClick }) {
  return (
    <button
      onClick={onClick} className="p-0.5"
    >
      <span className="panel-button hover:bg-cyan-200">
        <ScatterGlyph className="panel-button-icon text-green-700" />
      </span>
    </button>
  );
};

export function RemoveButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-red-300">
       <XMarkIcon className="panel-button-icon text-red-700" />
      </span>
    </button>
  );
}

export function DuplicateButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-purple-200">
       <DocumentDuplicateIcon className="panel-button-icon text-purple-600" />
      </span>
    </button>
  );
}


export function DownloadButton({ onClick, title = "Download Table Data (CSV)" }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
      title={title}
    >
      <span className="panel-button hover:bg-blue-300">
       <ArrowDownTrayIcon className="panel-button-icon text-blue-700" />
      </span>
    </button>
  );
}



export function NullButton({ onClick, isActive, title = "Toggle Null Value Exclusion" }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5 "
      title={title}
    >
      <span className={`inline-flex items-center justify-center w-6 h-6 rounded-lg
       ${isActive ? 'bg-blue-100' : 'bg-white'}
        border border-gray-400 hover:bg-blue-200`}>
       <NoSymbolIcon className="panel-button-icon text-blue-700" />
      </span>
    </button>
  );
}

export function SimpleRemoveButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="simple-panel-button hover:bg-red-300">
       <XMarkIcon className="simple-panel-button-icon" />
      </span>
    </button>
  );
}

export function TimePlotButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-green-300">
        <ArrowTrendingUpIcon className="panel-button-icon text-green-700" />
      </span>
    </button>
  );
}



export function MapButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-blue-300">
        <MapIcon className="panel-button-icon text-blue-700" />
      </span>
    </button>
  );
}

export function SearchButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className='p-0.5'
    >
      <span className="panel-button hover:bg-cyan-300">
        <MagnifyingGlassIcon className="panel-button-icon text-cyan-700" />
      </span>
    </button>
  );
}

export function BoxPlotButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-0.5"
    >
      <span className="panel-button hover:bg-red-200">
        <BoxPlotGlyph className="panel-button-icon text-red-700" />
      </span>
    </button>
  );
}



export function MergeButton({ onClick, isMergeSource }) {
  return (
    <button 
      onClick={onClick}
      className={`p-1 rounded-md transition-colors ${isMergeSource ? 'bg-blue-500 text-white' : 'hover:bg-gray-200 text-gray-600'}`}
      title="Merge with another table"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
      </svg>
    </button>
  );
}

export const ClearAllButton = ({ onClick }) => (
  <div className=" ">
    <div className="relative group">
      <button 
        onClick={onClick}
        className="px-2 py-1 bg-white border-[1.5px] border-red-800 rounded-full shadow-lg hover:bg-red-200 transition-all w-8 h-8 text-red-800"
      >
        X
      </button>
      <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 hidden group-hover:block bg-red-100 border-[1.5px] border-red-800 text-red-900 text-xs px-3 py-2 rounded-lg max-w-[220px] text-center">
       Click close all the panels and clear the data.
      </span>
    </div>
  </div>
);


export const DevelopmentButton = ({ onClick }) => (
  <div className="">
    <div className="relative group">
      <button 
        className="px-2 py-1 bg-white border-[1.5px] border-orange-600 text-orange-800 font-bold hover:bg-orange-200 shadow-lg rounded-full w-8 h-8"
        onClick={onClick}
      >    
          !
      </button>
      <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 hidden group-hover:block bg-orange-200 border-[1.5px] border-orange-800 text-orange-900 text-xs px-3 py-2 rounded-lg max-w-[220px] text-center">
       Note that this software is still under development, click and register your interest to be notified when the final tool will be released
      </span>
    </div>
  </div>
);

export const InstructionsButton = ({ onClick, showInstructions }) => (
  <div className=" ">
    <div className="relative group">
      <button 
        onClick={onClick}
        className="px-2 py-1 bg-white border-[1.5px] border-gray-800 rounded-full shadow-lg hover:bg-gray-200 transition-all w-8 h-8"
      >
        {showInstructions === false ? '?' : 'X'}
      </button>
      <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 hidden group-hover:block bg-gray-100 border-[1.5px] border-gray-800 text-gray-900 text-xs px-3 py-2 rounded-lg max-w-[220px] text-center">
       Click to open or close the panel with the project description and the tool instructions
      </span>
    </div>
  </div>
);

export const ViewModeButton = ({ onClick, viewMode }) => (
  <div className="">
    <button 
      onClick={onClick}
      className="px-1 py-1 bg-white border-[1.5px] border-gray-800 rounded-xl shadow-lg hover:bg-gray-200 transition-all w-16"
    >
      {viewMode === 'expert' ? 'Basic' : 'Expert'}
    </button>
  </div>
);

export const GeomEnrichButton = ({ onClick, compact }) => {
  if (compact) {
    return (
      <button onClick={onClick} className="-ml-4 h-[38px] w-[38px] px-1 rounded-full font-bold border-2 transition-colors flex items-center justify-center bg-gray-100 border-gray-400 text-gray-800 hover:bg-blue-100 shadow-sm" title="Enrich with extra Geographical Data">
        + G
      </button>
    );
  }
  return (
    <button onClick={onClick} className="px-3 py-4 border-[1.5px] rounded-xl font-bold shadow-sm bg-gray-100 border-gray-400 text-gray-800 hover:bg-blue-100 transition-all mr-2" title="Enrich with extra Geographical Data">
      + Geom
    </button>
  );
};

export const StatMenuButton = ({ onClick }) => (
  <button onClick={onClick} className="h-[38px] w-[38px] rounded-full font-bold border-2 transition-colors bg-gray-100 border-gray-400 text-gray-800 hover:bg-blue-100 shadow-sm">
    STAT
  </button>
);

export const FilterToggleButton = ({ onClick }) => (
  <button onClick={onClick} className="h-[38px] w-[38px] rounded-full font-bold border-2 transition-colors bg-gray-100 border-gray-400 text-gray-800 hover:bg-blue-100 shadow-sm">
    <AdjustmentsHorizontalIcon className="w-9 h-9 ml-[2.8px]" />
  </button>
);